import {Link, useLocation} from 'react-router-dom'
import {KTSVG} from '../../../helpers'
import { showErrorAlert } from '../../../../app/helpers/alert'

type Props = {
  to: string
  title: string
  icon?: string
  showIcon?: boolean
  showBadge?: boolean
  badgeCount?: number
  isSelected?: boolean
  disabled?: boolean
  // PR-I-80: entradas del menu que no navegan (feature "coming soon") reciben un
  // onClick que intercepta la navegacion para abrir un modal en su lugar.
  onClick?: (e: React.MouseEvent<HTMLAnchorElement>) => void
}

export function AsideMenuItem({
  to,
  title,
  icon,
  showIcon = false,
  showBadge = false,
  badgeCount = 0,
  isSelected = false,
  disabled = false,
  onClick,
}: Props) {
  const location = useLocation()
  const toPath = to.split('?')[0]
  const isActive = isSelected || location.pathname === toPath
  const link = disabled ? '#' : to

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    if (onClick) {
      e.preventDefault()
      onClick(e)
    }
  }

  return (
    <Link
      to={link}
      onClick={handleClick}
      className={`nb-menu-item ${isActive ? 'nb-menu-item--active' : 'nb-menu-item--inactive'}`}
    >
      {showIcon && icon && (
        <div className='nb-menu-icon'>
          <KTSVG path={icon} className='svg-icon-1' />
        </div>
      )}

      {isActive && (
        <div className='nb-menu-link'>
          <span className='nb-menu-title'>{title}</span>
          {showBadge && badgeCount > 0 && (
            <div className='nb-menu-badge'>
              <span className='nb-badge'>{badgeCount}</span>
            </div>
          )}
        </div>
      )}

      {!isActive && (
        <>
          <span className='nb-menu-title'>{title}</span>
          {showBadge && badgeCount > 0 && (
            <div className='nb-menu-badge'>
              <span className='nb-badge'>{badgeCount}</span>
            </div>
          )}
        </>
      )}
    </Link>
  )
}